// Gatsby requirements
import React from "react"

// Components that are connected to Storyblok
import Hero from 'components/sectionHero'
import Cards from 'components/sectionCards'
import TextAndImage from 'components/sectionTextAndImage'
import Logos from 'components/sectionLogos'
import CategoryList from 'components/sectionCategoryList'
import Testimonial from 'components/sectionTestimonial'
import Faq from 'components/sectionFaq'
import Cta from 'components/sectionCta'
import Table from 'components/sectionTable'
import AdList from 'components/sectionAdList'
import NumberedVerticalCards from 'components/sectionNumberedVerticalCards'
import ListOfArticles from 'components/sectionListOfArticles'
import Breadcrumbs from 'components/breadcrumbs'
import PricingCards from 'components/sectionPricingCards'
import ContactForm from 'components/sectionContactForm'
import Timeline from 'components/sectionTimeline'
import ProductComparison from 'components/sectionProductComparison'
import ShareButtons from 'components/sectionShareButtons'
import Html from 'components/sectionHtml'
import SectionReviews from 'components/sectionReviews'
import SectionReviewForm from 'components/sectionReviewForm'
import SectionProsAndCons from 'components/sectionProsAndCons'
import SectionOffers from 'components/offers'
import AgeConsentBanner from 'components/ageConsentBanner'

const StoryblokComponents = ({
    content, currentPage, currentPageName, en, offerTags,
    offers, offerPosition, currentPageId, offerText, offerBackgroundColor, offerAnchorId, offerRemoveTopMargin, offerRemoveBottomMargin,
}) => {

    let offersOnThisPage = [];

    offers && offers.forEach((loop) => {
        const offerData = JSON.parse(loop.node.content);

        // Check if offer should be shown on current page
        let shouldShow = offerData.showOn && offerData.showOn.includes(currentPageId);

        // Check if any tags match (only if both tag strings exist)
        if (offerTags && offerData?.offerTags) {
            const offerTagsArray = offerData.offerTags.toLowerCase().split(',').map(tag => tag.trim());
            const currentTagsArray = offerTags.toLowerCase().split(',').map(tag => tag.trim());
            
            const hasMatchingTag = offerTagsArray.some(tag => currentTagsArray.includes(tag));
            
            if (hasMatchingTag) {
                shouldShow = true;
            }
        }

        if (shouldShow) {
            offersOnThisPage.push(offerData);
        }
    })
  
    return (
        content?.map((blok, i) => (
            <>
                {i === offerPosition && offerPosition === 0 && offersOnThisPage.length > 0 &&
                    <SectionOffers
                        offers={offersOnThisPage}
                        offerText={offerText}
                        backgroundColor={offerBackgroundColor}
                        anchorId={offerAnchorId}
                        removeTopMargin={offerRemoveTopMargin}
                        removeBottomMargin={offerRemoveBottomMargin}
                    />
                }

                {blok.component === 'Section: Hero' && <Hero en={en} currentPageName={currentPageName} currentPage={currentPage}  key={blok._uid} blok={blok} /> }
                {blok.component === 'Section: Cards' && <Cards en={en} currentPageName={currentPageName} currentPage={currentPage}  key={blok._uid} blok={blok} /> }
                {blok.component === 'Section: Text and Image' && <TextAndImage en={en} currentPageName={currentPageName} currentPage={currentPage}  key={blok._uid} blok={blok} /> }
                {blok.component === 'Section: Logos' && <Logos en={en} currentPageName={currentPageName} currentPage={currentPage}  key={blok._uid} blok={blok} /> }
                {blok.component === 'Section: Category List' && <CategoryList en={en} currentPageName={currentPageName} currentPage={currentPage}  key={blok._uid} blok={blok} /> }
                {blok.component === 'Section: Testimonial' && <Testimonial en={en} currentPageName={currentPageName} currentPage={currentPage}  key={blok._uid} blok={blok} /> }
                {blok.component === 'Section: Faq' && <Faq en={en} currentPageName={currentPageName} currentPage={currentPage}  key={blok._uid} blok={blok} /> }
                {blok.component === 'Section: Call to Action' && <Cta en={en} currentPageName={currentPageName} currentPage={currentPage}  key={blok._uid} blok={blok} /> }
                {blok.component === 'Section: Table' && <Table en={en} currentPageName={currentPageName} currentPage={currentPage}  key={blok._uid} blok={blok} /> }
                {blok.component === 'Section: Ad List' && <AdList en={en} currentPageName={currentPageName} currentPage={currentPage}  key={blok._uid} blok={blok} /> }
                {blok.component === 'Section: Numbered Vertical Cards' && <NumberedVerticalCards en={en} currentPageName={currentPageName} currentPage={currentPage}  key={blok._uid} blok={blok} /> }
                {blok.component === 'Section: List of Articles' && <ListOfArticles en={en} currentPageName={currentPageName} currentPage={currentPage}  key={blok._uid} blok={blok} /> }
                {blok.component === 'Section: Breadcrumbs' && <span><Breadcrumbs en={en} currentPageName={currentPageName} currentPage={currentPage}  key={blok._uid} blok={blok} /></span> }
                {blok.component === 'Section: Pricing Cards' && <PricingCards en={en} currentPageName={currentPageName} currentPage={currentPage}  key={blok._uid} blok={blok} /> }
                {blok.component === 'Section: Contact Form' && <ContactForm en={en} currentPageName={currentPageName} currentPage={currentPage}  key={blok._uid} blok={blok} /> }
                {blok.component === 'Section: Timeline' && <Timeline en={en} currentPageName={currentPageName} currentPage={currentPage}  key={blok._uid} blok={blok} /> }
                {blok.component === 'Section: Product Comparison' && <ProductComparison en={en} currentPageName={currentPageName} currentPage={currentPage}  key={blok._uid} blok={blok} /> }
                {blok.component === 'Section: Share Buttons' && <ShareButtons en={en} currentPageName={currentPageName} currentPage={currentPage}  key={blok._uid} blok={blok} /> }
                {blok.component === 'Section: Html' && <Html en={en} currentPageName={currentPageName} currentPage={currentPage}  key={blok._uid} blok={blok} /> }
                {blok.component === 'Section: Reviews' && <SectionReviews en={en} currentPageName={currentPageName} currentPage={currentPage}  key={blok._uid} blok={blok} /> }
                {blok.component === 'Section: Pros and Cons' && <SectionProsAndCons en={en} currentPageName={currentPageName} currentPage={currentPage}  key={blok._uid} blok={blok} /> }
                {blok.component === 'Section: Review Form' && <SectionReviewForm en={en} currentPageName={currentPageName} currentPage={currentPage}  key={blok._uid} blok={blok} /> }
                {blok.component === 'Age Consent Banner' && <AgeConsentBanner blok={blok} /> }

                {i + 1 === offerPosition && offersOnThisPage.length > 0 &&
                    <SectionOffers
                        offers={offersOnThisPage}
                        offerText={offerText}
                        backgroundColor={offerBackgroundColor}
                        anchorId={offerAnchorId}
                        removeTopMargin={offerRemoveTopMargin}
                        removeBottomMargin={offerRemoveBottomMargin}
                    />
                }
            </>
        ))
    )
}

export default StoryblokComponents